<template>
  <div class="shop">
    <div class="campaign">
      <select v-model="selected">
        <option
          v-for="campaign in campaigns"
          :value="campaign.id"
          :key="campaign.id"
        >{{ campaign.name }}</option>
      </select>
    </div>
    <div class="store">
      <div v-for="product in products" :key="product.id" class="product">
        <img :src="require(`../assets/img/product${product.id}.png`)" />
        <div class="info">
          <h1>{{ product.name }}</h1>
          <h2>{{ product.amount | toUSD }}</h2>
          <h3>
            <span>+</span>
            {{ product.points }}
          </h3>
        </div>
        <a href="#" @click.prevent="buy(product)">Comprar</a>
      </div>
    </div>
    <QRModal ref="modalName">
      <template v-slot:header>
        <h1 class="qr-code-modal-title">Haz realizado una compra</h1>
      </template>

      <template v-slot:body>
        <div class="qr-code-image">
          <dl>
            <dt>Producto</dt>
            <dd>{{ selectedProduct.name }}</dd>
            <dt>Valor</dt>
            <dd>{{ selectedProduct.amount | toUSD }}</dd>
            <dt>Puntos</dt>
            <dd>+{{ selectedProduct.points }}</dd>
          </dl>

          <img src=" https://api.qrserver.com/v1/create-qr-code/?size=150x150&data=Example" />
        </div>
      </template>

      <template v-slot:footer>
        <div>
          <p>
            Captura este código QR por la compra de tu producto con laaplicación
            para acumular puntos
          </p>
        </div>
      </template>
    </QRModal>
  </div>
</template>

<script>
import QRModal from "@/components/QRModal";
//import axios from "axios";
export default {
  data: function() {
    return {
      url: "http://localhost:3000/fidelis/public/Campaign",
      selected: -1,
      selectedProduct: null,
      products: [
        { name: "Product 1", amount: 5000, points: 5, id: 1 },
        { name: "Product 2", amount: 10000, points: 10, id: 2 },
        { name: "Product 3", amount: 20000, points: 15, id: 3 }
      ],
      campaigns: []
    };
  },
  mounted() {
    /*axios(this.url, {
      method: "GET",
      headers: {
        crossDomain: true,
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "GET,PUT,POST,DELETE,PATCH,OPTIONS",
        "Access-Control-Allow-Headers": "Content-Type",
        Accept: "application/json",
        "Content-Type": "application/json"
      },

      credentials: "same-origin",
      crossdomain: true
    })
      .then(response => {
        console.log(response);
        this.campaigns = response.data;
        this.campaigns.push({ name: "Seleccione una Campaña", id: -1 });
      })
      .catch(error => {
        console.log(error);
        this.errored = true;
      })
      .finally(() => (this.loading = false));*/
    const response = fetch(this.url, {
      method: "GET", // *GET, POST, PUT, DELETE, etc.
      mode: "cors", // no-cors, *cors, same-origin
      cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
      credentials: "same-origin", // include, *same-origin, omit
      headers: {
        "Access-Control-Allow-Origin": "*",
        "Content-Type": "application/json"
        // 'Content-Type': 'application/x-www-form-urlencoded',
      },
      redirect: "follow", // manual, *follow, error
      referrerPolicy: "no-referrer" // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
    });
    console.log(response);
  },
  methods: {
    buy: function(p) {
      console.log(p.id);
      this.selectedProduct = p;
      this.$refs.modalName.openModal();
    }
  },
  filters: {
    toUSD(value) {
      return `$${value.toLocaleString()}`;
    }
  },
  components: {
    QRModal
  }
};
</script>
